import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LogoutComponent } from './components/logout/logout.component';

const routes: Routes = [
    { path: ':systemKey', component: LogoutComponent },
    { path: ':systemKey/:clinicId', component: LogoutComponent },
    {
        path: '**',
        loadChildren: () =>
            import('../not-found/not-found.module').then(
                (m) => m.NotFoundModule
            ),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LogoutRoutingModule {}
